<template>
  <div class="home-page">
    <el-container>
      <el-header class="header">
        <div>
          <span class="logo" @click="toSpot" :class="isSpotTab ? 'active' : ''">现货</span>
          <span v-if="!isCustom || isRiskAccount" class="logo" @click="toTigger"
            :class="showFutures ? 'active' : ''">合约</span>
          <span v-if="!isCustom" class="logo" @click="toBackend" :class="isBackendTab ? 'active' : ''">后台</span>
          <!-- <span v-if="!isCustom" class="logo" @click="toOTC">OTC</span> -->
          <!-- <span
            v-if="!isCustom"
            class="logo"
            @click="toFinancial"
            :class="showFinancial ? 'active' : ''"
            >理财</span
          > -->
          <!-- <span  class="logo" @click="toReport">FinancialStatements</span> -->
        </div>
        <!-- <iframe src="//www.baidu.com" width="100%" height="60" frameborder="0"></iframe> -->
        <div class="profile">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              {{ userInfo.name }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <a @click="showChangePassword" class="exit">修改密码</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a @click="logout" class="exit">退出</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dialog title="修改密码" :visible.sync="changePasswordVisible" width="420px" :close-on-click-modal="false"
            @close="closeChangePasswordDialog">
            <el-form label-width="110px">
              <el-form-item label="旧密码">
                <el-input v-model.trim="changePasswordForm.oldPassword" type="password" show-password
                  autocomplete="current-password"></el-input>
              </el-form-item>
              <el-form-item label="新密码">
                <el-input v-model.trim="changePasswordForm.newPassword" type="password" show-password
                  autocomplete="new-password"></el-input>
              </el-form-item>
              <el-form-item label="确认新密码">
                <el-input v-model.trim="changePasswordForm.confirmPassword" type="password" show-password
                  autocomplete="new-password"></el-input>
              </el-form-item>
              <div style="color: #909399; line-height: 20px">
                密码至少8位，且必须包含数字、大写字母、小写字母和符号
              </div>
            </el-form>
            <div slot="footer">
              <el-button @click="closeChangePasswordDialog">取消</el-button>
              <el-button type="primary" @click="submitChangePassword">确定</el-button>
            </div>
          </el-dialog>
          <el-dialog title="谷歌验证码" :visible.sync="googleDialogVisible" width="320px" :close-on-click-modal="false"
            @close="closeGoogleDialog">
            <el-form label-width="100px">
              <el-form-item label="谷歌验证码">
                <el-input v-model.trim="googleForm.googleCode" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button @click="closeGoogleDialog">取消</el-button>
              <el-button type="primary" @click="confirmGoogleForPassword">确定</el-button>
            </div>
          </el-dialog>
        </div>
      </el-header>
      <el-container style="height: 100%">
        <!-- <div v-if="showSpot"> -->
        <el-aside v-if="showSpot" class="aside" height="100%" width="220px">
          <!-- <img
            :src="isCollapse ? collapseActive : collapseImg"
            alt=""
            class="collapseImg"
            @click="isCollapse = !isCollapse"
          /> -->
          <!-- :collapse="isCollapse" -->
          <el-menu :router="true" :default-active="this.$route.path">
            <!-- <el-menu-item index="/home/dashboard">
              <i class="el-icon-picture-outline"></i>
              <span slot="title">仪表盘</span>
            </el-menu-item>-->
            <el-submenu index="/home/spotConfig" v-if="isSpotTab">
              <template slot="title">
                <svgicon name="setting" original scale="1" class="svg-icon" />
                <span slot="title">现货配置</span>
              </template>
              <el-menu-item index="/home/setting/config-i18n" v-if="!isRiskAccount">
                <template slot="title">
                  <span slot="title">国际化配置</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/setting/tradePair">
                <template slot="title">
                  <span slot="title">交易对设置</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/setting/robot">
                <template slot="title">
                  <span slot="title">机器人设置</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/setting/spotCoinAdmin">
                <template slot="title">
                  <span slot="title">现货币种设置</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/setting/spotKlineRepair">
                <template slot="title">
                  <span slot="title">现货k线修复</span>
                </template>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="/home/audit" v-if="isBackendTab">
              <template slot="title">
                <svgicon name="audit" original scale="1" class="svg-icon" />

                <span slot="title">审批管理</span>
              </template>
              <el-menu-item index="/home/audit/withdrawal">
                <template slot="title">
                  <span slot="title">链上提现审批</span>
                </template>
              </el-menu-item>
              <!-- <el-menu-item index="/home/audit/otc">
                <template slot="title">
                  <span slot="title">OTC出金审核</span>
                </template>
              </el-menu-item> -->
              <el-menu-item index="/home/audit/kyc">
                <template slot="title">
                  <span slot="title">KYC认证审批</span>
                </template>
              </el-menu-item>
              <!-- <el-menu-item index="/home/audit/c2c">
                <template slot="title">
                  <TransactionOrder
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/audit/c2c'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">C2C订单审批</span>
                </template>
              </el-menu-item> -->
              <!-- <el-menu-item index="/home/audit/c2cAll">C2C全量订单</el-menu-item> -->
              <el-menu-item index="/home/audit/logLimit">
                <template slot="title">
                  <span slot="title">审批登录限制</span>
                </template>
              </el-menu-item>
              <!-- <el-menu-item index="/home/audit/transfer">
                <template slot="title">
                  <BankTransfer
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/audit/transfer'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">转账审批</span>
                </template>
              </el-menu-item> -->
              <!-- <el-menu-item index="/home/audit/merchant">商户&币种设置</el-menu-item> -->
              <!-- <el-menu-item index="/home/audit/transfer" v-if="!isCustom">
                <template slot="title">
                  <BankTransfer
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/audit/transfer'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">转账审批</span>
                </template>
              </el-menu-item> -->
              <!-- <el-submenu index="/home/audit/deposite">
                <template slot="title">
                  <Paypal
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :strokeWidth="1"
                  />
                  <span slot="title">充值审批</span>
                </template> -->
              <el-menu-item index="/home/audit/deposite" v-if="!isCustom">
                <template slot="title">
                  <span slot="title">充值审批</span>
                </template>
              </el-menu-item>
              <!-- <el-menu-item index="/home/audit/cashOut">
                <template slot="title">
                  <Application
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/audit/cashOut'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">出金审批</span>
                </template>
              </el-menu-item> -->

              <el-menu-item index="/home/audit/deposite/records">
                <span slot="title">充值记录</span>
              </el-menu-item>
              <el-menu-item index="/home/audit/withdraw/records">
                <span slot="title">提现记录</span>
              </el-menu-item>
              <!-- <el-menu-item index="/home/audit/otcdeposite">
                <span slot="title">法币入金</span>
              </el-menu-item>

              <el-menu-item index="/home/audit/otcwithdraw">
                <span slot="title">法币出金</span>
              </el-menu-item> -->
              <el-menu-item index="/home/audit/feedback">
                <span slot="title">意见反馈</span>
              </el-menu-item>
              <!-- <el-menu-item index="/home/audit/otcBuyLimit">
                <span slot="title">otc买币限制</span>
              </el-menu-item> -->
              <el-menu-item index="/home/audit/authLimit">
                <span slot="title">安全验证限制</span>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="/home/userControl" v-if="showFullSpotMenus">
              <template slot="title">
                <svgicon name="userControl" original scale="1" class="svg-icon" />
                <span slot="title">用户管理</span>
              </template>
              <el-menu-item index="/home/userOld">
                <template slot="title">
                  <span slot="title">用户基本信息</span>
                </template>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="/home/spotFundFlow" v-if="showFullSpotMenus">
              <template slot="title">
                <svgicon name="transactions" original scale="1" class="svg-icon" />
                <span slot="title">资金流水</span>
              </template>
              <el-menu-item index="/home/spotBill">
                <span slot="title">现货资金流水</span>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="/home/backendUserControl" v-if="showFullBackendMenus">
              <template slot="title">
                <svgicon name="userControl" original scale="1" class="svg-icon" />
                <span slot="title">用户管理</span>
              </template>
              <el-menu-item index="/home/userLoginLog">
                <span slot="title">用户登录历史</span>
              </el-menu-item>
              <el-menu-item index="/home/userOrderLog">
                <span slot="title">下单IP设备查询</span>
              </el-menu-item>
              <el-menu-item index="/home/verifyCodeHistory">
                <template slot="title">
                  <span slot="title">验证码历史记录</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/address">
                <template slot="title">
                  <span slot="title">用户地址查询</span>
                </template>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="/home/user" v-if="showFullBackendMenus">
              <template slot="title">
                <svgicon name="partner" original scale="1" class="svg-icon" />

                <span slot="title">合伙人管理</span>
              </template>
              <el-menu-item index="/home/funds">
                <span slot="title">资金概览</span>
              </el-menu-item>
              <el-menu-item index="/home/rebateList">
                <span slot="title">返佣列表</span>
              </el-menu-item>

              <el-menu-item index="/home/rebateReview">
                <span slot="title">返佣审核</span>
              </el-menu-item>
              <el-menu-item index="/home/rebateRisk">
                <span slot="title">风控列表</span>
              </el-menu-item>
              <el-menu-item index="/home/partnerList">
                <span slot="title">合伙人列表</span>
              </el-menu-item>
              <el-menu-item index="/home/giftCoin">
                <span slot="title">赠币管理</span>
              </el-menu-item>
              <el-menu-item index="/home/friend">
                <span slot="title">好友列表</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="/home/backendFundFlow" v-if="showFullBackendMenus">
              <template slot="title">
                <svgicon name="transactions" original scale="1" class="svg-icon" />
                <span slot="title">资金流水</span>
              </template>
              <el-menu-item index="/home/contractBill">
                <span slot="title">合约资金流水</span>
              </el-menu-item>
              <!-- <el-menu-item index="/home/otcBill">
                <span slot="title">otc资金流水</span>
              </el-menu-item> -->
              <el-menu-item index="/home/spotBill">
                <span slot="title">现货资金流水</span>
              </el-menu-item>
              <el-menu-item index="/home/transferRecord">
                <span slot="title">划转记录</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="/home/activity" v-if="showFullBackendMenus">
              <template slot="title">
                <svgicon name="robot" original scale="1" class="svg-icon" />
                <span slot="title">福利中心</span>
              </template>
              <el-menu-item index="/home/activity/management">
                <span slot="title">任务管理</span>
              </el-menu-item>
              <el-menu-item index="/home/activity/record/taskData">
                <span slot="title">任务记录</span>
              </el-menu-item>
              <el-menu-item index="/home/activity/lottery">
                <span slot="title">奖券管理</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="/home/transactions" v-if="showFullSpotMenus">
              <template slot="title">
                <svgicon name="transactions" original scale="1" class="svg-icon" />
                <span slot="title">合约交易管理</span>
              </template>
              <el-menu-item index="/home/contractPosition">
                <span slot="title">当前持仓</span>
              </el-menu-item>
              <el-menu-item index="/home/currentDelegation">
                <span slot="title">当前委托</span>
              </el-menu-item>
              <el-menu-item index="/home/historyDelegation">
                <span slot="title">历史委托</span>
              </el-menu-item>
              <el-menu-item index="/home/closingCommission">
                <span slot="title">平仓记录</span>
              </el-menu-item>

              <el-menu-item index="/home/transactionRecord">
                <span slot="title">开仓记录</span>
              </el-menu-item>
              <el-menu-item index="/home/contractHistory">
                <span slot="title">历史仓位记录</span>
              </el-menu-item>
              <el-menu-item index="/home/transactionSummary">
                <span slot="title">净盈亏查询</span>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="/home/dataAnalysis" v-if="!isCustom && showFullSpotMenus">
              <template slot="title">
                <svgicon name="dataAnalysis" original scale="1" class="svg-icon" />
                <span slot="title">数据管理</span>
              </template>
              <!-- <el-menu-item index="/home/report">
                <span slot="title">统计报表</span>
              </el-menu-item> -->
              <el-menu-item index="/home/transactionStatistics">
                <span slot="title">交易统计 </span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="/home/simulation" v-if="showFullSpotMenus">
              <template slot="title">
                <svgicon name="simulation" original scale="1" class="svg-icon" />

                <span slot="title">模拟管理</span>
              </template>
              <el-menu-item index="/home/simulation/mockUp">
                <span slot="title">模拟充提</span>
              </el-menu-item>
              <el-menu-item index="/home/simulation/transferInnerMock">
                <span slot="title">模拟盘转账</span>
              </el-menu-item>
              <el-menu-item index="/home/simulation/registration">
                <span slot="title">模拟用户信息</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="/home/tiger" v-if="showFullSpotMenus">
              <template slot="title">
                <svgicon name="tiger" original scale="1" class="svg-icon" />

                <span slot="title">合约持仓管理</span>
              </template>
              <el-menu-item index="/home/tiger/head-inch">
                <span slot="title">仓位净头寸</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="/home/history" v-if="showFullSpotMenus">
              <template slot="title">
                <svgicon name="history" original scale="1" class="svg-icon" />

                <span slot="title">合约历史管理</span>
              </template>
              <el-menu-item index="/home/tiger/active-history">
                <span slot="title">活跃委托历史</span>
              </el-menu-item>
              <el-menu-item index="/home/tiger/plan-history">
                <span slot="title">计划委托历史</span>
              </el-menu-item>
              <el-menu-item index="/home/tiger/profitLoss-history">
                <span slot="title">止盈止损历史</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="home/entrust" v-if="showFullSpotMenus">
              <template slot="title">
                <svgicon name="entrust" original scale="1" class="svg-icon" />

                <span slot="title">合约委托管理</span>
              </template>
              <el-menu-item index="/home/tiger/active">
                <span slot="title">限价委托</span>
              </el-menu-item>
              <el-menu-item index="/home/tiger/plan">
                <span slot="title">计划委托</span>
              </el-menu-item>
              <el-menu-item index="/home/tiger/profitLoss">
                <span slot="title">止盈止损</span>
              </el-menu-item>
              <el-menu-item index="/home/tiger/moveProfitLoss">
                <span slot="title">移动止盈止损</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="/home/otherFun" v-if="showFullBackendMenus">
              <template slot="title">
                <svgicon name="otherFun" original scale="1" class="svg-icon" />

                <span slot="title">其他功能</span>
              </template>

              <!-- <el-submenu index="/home/purchase" v-if="userInfo.isSupper">
                <template slot="title">
                  <i class="el-icon-goods"></i>
                  <span slot="title">申购管理</span>
                </template>
                <el-menu-item index="/home/purchase/projects"
                  >普通申购</el-menu-item
                >
                <el-menu-item index="/home/purchase/records"
                  >普通申购记录</el-menu-item
                >
                <el-menu-item index="/home/purchase/discount"
                  >五折申购</el-menu-item
                >
                <el-menu-item index="/home/purchase/discountRecords"
                  >五折抽奖记录</el-menu-item
                >
              </el-submenu>
              <el-submenu
                index="/home/c2c"
                v-if="userInfo.roleId === 1 || userInfo.roleId === 0"
              >
                <template slot="title">
                  <SettingOne
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/c2c' ? '#409EFF' : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">C2C设置</span>
                </template>
                <el-menu-item index="/home/audit/c2c">C2C订单审批</el-menu-item>
                <el-menu-item index="/home/audit/c2cAll"
                  >C2C全量订单</el-menu-item
                >
                <el-menu-item index="/home/audit/merchant"
                  >商户&币种设置</el-menu-item
                >
                <el-menu-item index="/home/c2c/settlement"
                  >C2C结算</el-menu-item
                >
              </el-submenu>
              <el-submenu index="/home/cornucopia">
               
                <template slot="title">
                  
                  <Finance
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/cornucopia'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">聚宝盆</span>
                </template>

                <el-submenu index="/home/cornucopia/projects">
                  <template slot="title">
                    <span slot="title">活期宝</span>
                  </template>
                  <el-menu-item index="/home/cornucopia/projects"
                    >活期宝设置</el-menu-item
                  >
                  <el-menu-item index="/home/cornucopia/records"
                    >活期宝利息列表</el-menu-item
                  >
                  <el-menu-item index="/home/cornucopia/lock"
                    >活期宝存币记录</el-menu-item
                  >
                </el-submenu>
                <el-submenu index="/home/cornucopia/pledgeSetting">
                  <template slot="title">
                    <span slot="title">定期宝</span>
                  </template>
                  <el-menu-item index="/home/cornucopia/pledgeSetting"
                    >定期宝设置</el-menu-item
                  >
                  <el-menu-item index="/home/cornucopia/pledgeRecord"
                    >定期宝存币记录</el-menu-item
                  >
                </el-submenu>
                <el-submenu index="/home/cornucopia/mortgage">
                  <template slot="title">
                    <span slot="title">抵押贷款</span>
                  </template>
                  <el-menu-item index="/home/cornucopia/mortgage"
                    >抵押贷款</el-menu-item
                  >
                  <el-menu-item index="/home/cornucopia/cycle"
                    >抵押贷款周期设置</el-menu-item
                  >
                  <el-menu-item index="/home/cornucopia/mortgagerecord"
                    >抵押贷款列表</el-menu-item
                  >
                </el-submenu>
                <el-submenu index="/home/cornucopia/mining">
                  <template slot="title">
                    <span slot="title">云算力</span>
                  </template>
                  <el-menu-item index="/home/cornucopia/mining"
                    >云算力列表</el-menu-item
                  >
                  <el-menu-item index="/home/cornucopia/miningBuy"
                    >云算力购买记录</el-menu-item
                  >
                  <el-menu-item index="/home/cornucopia/miningRocord"
                    >云算力利息列表</el-menu-item
                  >
                </el-submenu>
              </el-submenu> -->
              <!-- <el-menu-item index="/home/qrcodes">
              
                <template slot="title">
                 
                  <TwoDimensionalCodeTwo
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/qrcodes'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">客服群二维码</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/airdrop" v-if="userInfo.roleId === 0">
                <i class="el-icon-sold-out"></i>
                <span slot="title">空投设置</span>
              </el-menu-item> -->
              <el-menu-item index="/home/airdrop" v-if="!isCustom">
                <span slot="title">空投设置</span>
              </el-menu-item>
              <el-menu-item index="/home/maintenance" v-if="!isCustom">
                <span slot="title">系统维护公告</span>
              </el-menu-item>
              <el-menu-item index="/home/transferInner" v-if="!isCustom">
                <span slot="title">内部转帐</span>
              </el-menu-item>

              <el-menu-item index="/home/app" v-if="!isCustom">
                <span slot="title">APP设置</span>
              </el-menu-item>
              <!-- <el-menu-item index="/home/commission" v-if="!isCustom">
                <span slot="title">返佣设置</span>
              </el-menu-item> -->
              <el-menu-item index="/home/siteConf" v-if="!isCustom">
                <span slot="title">siteConf设置</span>
              </el-menu-item>
              <!-- <el-menu-item index="/home/api/log">
              
                <template slot="title">
                  <Api
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/qrcodes'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">API 请求日志</span>
                </template>
              </el-menu-item> -->
            </el-submenu>

            <el-submenu index="/home/orderManagement" v-if="!isCustom && showFullSpotMenus">
              <template slot="title">
                <svgicon name="management" original scale="1" class="svg-icon" />
                <span slot="title">委托管理</span>
              </template>
              <el-menu-item index="/home/orderLimit"><template slot="title">
                  <span slot="title">限价委托</span>
                </template></el-menu-item>
              <!-- <el-menu-item
                index="/home/orderPlan"
               
              >
                <template slot="title">
                  <i class="el-icon-set-up"></i>
                  <span slot="title">计划委托</span>
                </template></el-menu-item
              > -->
            </el-submenu>
            <!-- <el-submenu index="/home/otc" v-if="showFullSpotMenus">
              <template slot="title">
                <svgicon name="otc" original scale="1" class="svg-icon" />

                <span slot="title">OTC管理</span>
              </template>
              <el-menu-item index="/home/otc/otcUserList">
                <template slot="title">
                  <span slot="title">otc用户列表</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/otc/payList">
                <template slot="title">
                  <span slot="title">支付方式</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/otc/orderList">
                <template slot="title">
                  <span slot="title">订单管理</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/otc/chatList">
                <template slot="title">
                  <span slot="title">聊天记录列表</span>
                </template>
              </el-menu-item>
              <el-submenu index="/home/merchant" class="sub">
                <template slot="title">
                  <span slot="title">商家管理</span>
                </template>
                <el-menu-item index="/home/otc/storeList">
                  <template slot="title">
                    <span slot="title">商家列表</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/home/otc/merchantList">
                  <template slot="title">
                    <span slot="title">商户申请记录列表</span>
                  </template>
                </el-menu-item>
              </el-submenu>
              <el-submenu index="/home/ad" class="sub">
                <template slot="title">
                  <span slot="title">广告管理</span>
                </template>
                <el-menu-item index="/home/otc/adverList">
                  <template slot="title">
                    <span slot="title">广告管理列表</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/home/otc/currencyList">
                  <template slot="title">
                    <span slot="title">广告币种配置</span>
                  </template>
                </el-menu-item>
              </el-submenu>
              <el-menu-item index="/home/otc/appealList">
                <template slot="title">
                  <span slot="title">申诉管理</span>
                </template>
              </el-menu-item>
            </el-submenu> -->
            <el-submenu index="/home/setting" v-if="!isCustom && showFullBackendMenus">
              <template slot="title">
                <svgicon name="setting" original scale="1" class="svg-icon" />
                <span slot="title">系统设置</span>
              </template>

              <!-- <el-menu-item
                index="/home/setting/KLineRepair"
                v-if="userInfo.roleId === 0"
              >
                <template slot="title">
                  <Toolkit
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/setting/KLineRepair'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">K线修复</span>
                </template>
              </el-menu-item> -->

              <el-menu-item index="/home/setting/countryCode">
                <template slot="title">
                  <span slot="title">国家码设置</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/setting/appLineUrl">
                <template slot="title">
                  <span slot="title">app链接设置</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/setting/telegram">
                <template slot="title">
                  <span slot="title">社媒链接管理</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/setting/functionUrlConfig">
                <template slot="title">
                  <span slot="title">公告与链接管理</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/setting/channel">
                <template slot="title">
                  <span slot="title">渠道信息设置</span>
                </template>
              </el-menu-item>
              <!-- <el-menu-item index="/home/setting/priceControl">
                <template slot="title">
                  <Control
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/setting/priceControl'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">价格控制</span>
                </template>
              </el-menu-item> -->
              <!-- <el-menu-item
                index="/home/setting/chatroom"
                v-if="userInfo.roleId === 0"
              >
                <template slot="title">
                  <Communication
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/setting/chatroom'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">聊天室设置</span>
                </template>
              </el-menu-item> -->
              <!-- <el-menu-item index="/home/setting/poster">
                <template slot="title">
                  <span slot="title">海报设置</span>
                </template>
              </el-menu-item> -->
              <el-menu-item index="/home/setting/banner">
                <template slot="title">
                  <span slot="title">Banner设置</span>
                </template>
              </el-menu-item>
              <!-- <el-menu-item index="/home/setting/AppStartPage">
                <template slot="title">
                  <span slot="title">App启动页配置</span>
                </template>
              </el-menu-item> -->
              <el-menu-item index="/home/setting/nodeConfig">
                <template slot="title">
                  <span slot="title">节点配置</span>
                </template>
              </el-menu-item>
              <!-- <el-menu-item index="/home/setting/AppAdvertisePage">
                <template slot="title">
                  <AdProduct
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/setting/AppAdvertisePage'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">App广告页配置</span>
                </template>
              </el-menu-item> -->

              <!-- <el-menu-item index="/home/setting/AppFunctionalPage">
                <template slot="title">
                  <Application
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/setting/AppFunctionalPage'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">App金刚区配置</span>
                </template>
              </el-menu-item> -->
              <!--  <el-menu-item
                index="/home/setting/walletSwitch"
                v-if="userInfo.roleId === 0"
              >
                <template slot="title">
                  <Wallet
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/setting/walletSwitch'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">钱包开关</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/home/setting/walletSwitchCold"
                v-if="userInfo.roleId === 0"
              >
                <template slot="title">
                  <FreezeColumn
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/setting/walletSwitchCold'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">钱包转冷设置</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/home/setting/processorConfig"
                v-if="userInfo.roleId === 0"
              >
                <template slot="title">
                  <MindMapping
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/setting/processorConfig'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">Processor设置</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/setting/banner">
                <template slot="title">
                  <Carousel
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/setting/banner'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">Banner设置</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/setting/content">
                <template slot="title">
                  <ParagraphUnfold
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/setting/content'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">内容设置</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/setting/push">
                <template slot="title">
                  <EmailPush
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/setting/push'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">推送设置</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/setting/community">
                <template slot="title">
                  <BuildingOne
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/setting/community'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="1"
                  />
                  <span slot="title">社区设置</span>
                </template>
              </el-menu-item> -->
            </el-submenu>
            <!-- 财务报表 -->
            <!-- <el-submenu index="/home/financialStatements" v-if="!isCustom">
              <template slot="title">
                <svgicon
                  name="financialStatements"
                  original
                  scale="1"
                  class="svg-icon"
                />

                <span slot="title">财务报表</span>
              </template>
              <el-menu-item index="/home/financeReport/financeOrder">
                <span slot="title">现货订单</span>
              </el-menu-item>
              <el-menu-item index="/home/financeReport/financeBill">
                <span slot="title">综合账单</span>
              </el-menu-item>
              <el-menu-item index="/home/financeReport/financeBalance">
                <span slot="title">余额账单</span>
              </el-menu-item>
              <el-menu-item index="/home/financeReport/financeTrade">
                <span slot="title">成交账单</span>
              </el-menu-item>
              <el-menu-item index="/home/financeReport/AddressBalance">
                <span slot="title">地址余额</span>
              </el-menu-item>
            </el-submenu> -->
            <el-submenu index="/home/currencyManagement" v-if="!isCustom && showFullBackendMenus">
              <template slot="title">
                <svgicon name="coin" original scale="1" class="svg-icon" />

                <span slot="title">币种管理</span>
              </template>
              <el-menu-item index="/home/setting/currency">
                <template slot="title">
                  <span slot="title">充提币种设置</span>
                </template></el-menu-item>
              <el-menu-item index="/home/setting/currencyTransfer">
                <template slot="title">
                  <span slot="title">币种划转设置</span>
                </template></el-menu-item>
              <el-menu-item index="/home/setting/currencyIntroduction"><template slot="title">
                  <span slot="title">币种介绍设置</span>
                </template></el-menu-item>
            </el-submenu>
            <!-- <el-submenu index="/home/sweepBlock" v-if="!isCustom">
              <template slot="title">
                <svgicon
                  name="sweepBlock"
                  original
                  scale="1"
                  class="svg-icon"
                />
                <span slot="title">扫块管理</span>
              </template>
              <el-menu-item index="/home/blockInfo"
                ><template slot="title">
                  <span slot="title">块信息</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/blockHeightTask"
                ><template slot="title">
                  <span slot="title">高度任务</span>
                </template>
              </el-menu-item>
            </el-submenu> -->
            <el-submenu index="/home/tenantAdmin" v-if="!isCustom && showFullBackendMenus">
              <template slot="title">
                <svgicon name="coin" original scale="1" class="svg-icon" />
                <span slot="title">租户管理</span>
              </template>
              <el-menu-item index="/home/tenant/contractCoin">
                <template slot="title">
                  <span slot="title">租户合约交易对</span>
                </template></el-menu-item>
              <el-menu-item index="/home/tenant/coin">
                <template slot="title">
                  <span slot="title">租户币种</span>
                </template></el-menu-item>
              <el-menu-item index="/home/tenant/spotCoin"><template slot="title">
                  <span slot="title">租户现货交易对</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/tenant/config"><template slot="title">
                  <span slot="title">租户设置</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/tenant/walletConfig"><template slot="title">
                  <span slot="title">租户钱包配置</span>
                </template>
              </el-menu-item>

              <el-menu-item index="/home/tenant/tenantUserAdmin"><template slot="title">
                  <span slot="title">租户管理端用户设置</span>
                </template>
              </el-menu-item>

              <el-menu-item index="/home/tenant/menu"><template slot="title">
                  <span slot="title">租户菜单管理</span>
                </template>
              </el-menu-item>

              <el-menu-item index="/home/tenant/role"><template slot="title">
                  <span slot="title">租户角色管理</span>
                </template>
              </el-menu-item>

              <el-menu-item index="/home/tenant/tenantS3Admin"><template slot="title">
                  <span slot="title">租户s3设置</span>
                </template>
              </el-menu-item>

              <el-menu-item index="/home/tenant/tenantOss"><template slot="title">
                  <span slot="title">租户oss配置</span>
                </template>
              </el-menu-item>

              <el-menu-item index="/home/tenant/tenantSpconfig"><template slot="title">
                  <span slot="title">租户期权配置</span>
                </template>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="/home/systemPermission" v-if="!isCustom && showFullBackendMenus">
              <template slot="title">
                <svgicon name="setting" original scale="1" class="svg-icon" />
                <span slot="title">系统权限管理</span>
              </template>
              <el-menu-item index="/home/system/menu">
                <template slot="title">
                  <span slot="title">菜单管理</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/system/role">
                <template slot="title">
                  <span slot="title">角色管理</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/system/user">
                <template slot="title">
                  <span slot="title">系统用户管理</span>
                </template>
              </el-menu-item>
            </el-submenu>
            <!-- <el-submenu index="/home/gas" v-if="!isCustom">
              <template slot="title">
                <svgicon name="gas" original scale="1" class="svg-icon" />
                <span slot="title">Gas和阈值管理</span>
              </template>
              <el-menu-item index="/home/gas"
                ><template slot="title">
                  <span slot="title">Gas和阈值</span>
                </template></el-menu-item
              >
            </el-submenu> -->
            <!-- <el-submenu index="/home/robot" v-if="!isCustom">
              <template slot="title">
                <svgicon name="robot" original scale="1" class="svg-icon" />

                <span slot="title">交易机器人设置</span>
              </template>

              <el-menu-item index="/home/robot/info">
                <template slot="title">
                  <span slot="title">机器人 Info</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/robot/robotPairConfig">
                <template slot="title">
                  <span slot="title">机器人启动-交易对配置</span>
                </template>
              </el-menu-item>
            </el-submenu> -->
            <!-- <el-menu-item index="/home/audit/deposite">充值审批</el-menu-item> -->
            <!-- </el-submenu> -->

            <!-- <el-submenu index="/home/foundation" v-if="userInfo.isSupper"> -->
            <!-- <el-submenu index="/home/foundation" v-if="!isCustom">
              <template slot="title">
                 
                <span slot="title">预售</span>
              </template>
              <el-menu-item index="/home/foundation/projects"
                >项目列表</el-menu-item
              >
              <el-menu-item index="/home/foundation/records"
                >抢购记录</el-menu-item
              >
            </el-submenu> -->
            <!-- <el-submenu index="/home/kpi" v-if="userInfo.roleType > 10">
              <template slot="title">
                <i class="el-icon-star-off"></i>
                <span slot="title">kpi</span>
              </template>
              <el-menu-item index="/home/kpi/staff">员工详情</el-menu-item>
              <el-menu-item index="/home/kpi/projects">员工奖励</el-menu-item>
              <el-menu-item index="/home/kpi/records">kpi列表</el-menu-item>
            </el-submenu> -->
            <!-- <el-submenu index="/home/star" v-if="userInfo.isSupper">
              <template slot="title">
                <i class="el-icon-star-off"></i>
                <span slot="title">繁星计划</span>
              </template>
              <el-menu-item index="/home/star/setnode">节点设置</el-menu-item>
              <el-menu-item index="/home/star/records">新人信息</el-menu-item>
            </el-submenu> -->

            <!-- <el-submenu index="/home/league" v-if="userInfo.isSupper">
              <template slot="title">
                <i class="el-icon-s-flag"></i>
                <span slot="title">武侠管理</span>
              </template>
              <el-menu-item index="/home/league/list">门派列表</el-menu-item>
              <el-menu-item index="/home/league/label">名号设置</el-menu-item>
              <el-menu-item index="/home/league/records">锁仓记录</el-menu-item>
              <el-submenu index="/home/league/settle">
                <template slot="title">
                  <span slot="title">武侠结算</span>
                </template>
                <el-menu-item index="/home/league/settle"
                  >结算设置</el-menu-item
                >
                <el-menu-item index="/home/league/settle/records"
                  >结算列表</el-menu-item
                >
              </el-submenu>
            </el-submenu> -->

            <!-- <el-menu-item index="/home/notice">
              <i class="el-icon-bell"></i>
              <span slot="title">弹出消息</span>
            </el-menu-item>-->

            <!-- <el-submenu index="/home/lever" v-if="userInfo.isSupper">
              <template slot="title">
                <i class="el-icon-s-flag"></i>
                <span slot="title">杠杆交易</span>
              </template>
              <el-menu-item index="/home/lever/list">杠杆列表</el-menu-item>
              <el-menu-item index="/home/lever/records">交易记录</el-menu-item>
            </el-submenu> -->

            <!-- <el-menu-item index="/home/announcement">
             
              <template slot="title">
                <Announcement
                  :style="iconStyle"
                  theme="outline"
                  size="18"
                  :fill="
                    this.$route.path == '/home/announcement'
                      ? '#409EFF'
                      : '#303133'
                  "
                  :strokeWidth="2"
                />
                <span slot="title">公告录入</span>
              </template>
            </el-menu-item> -->

            <!-- <el-submenu index="/home/ticket">
              <template slot="title">
                <i class="el-icon-tickets"></i>
                <span slot="title">工单处理</span>
              </template>
              <el-menu-item index="/home/ticket/loginUser">登录用户</el-menu-item>
              <el-menu-item index="/home/ticket/notLoggedInUser">未登录用户</el-menu-item>
            </el-submenu>-->
            <!-- <el-menu-item index="/home/wallet">
              <i class="el-icon-goods"></i>
              <span slot="title">冷热钱包监控</span>
            </el-menu-item>
            <el-menu-item index="/home/reconciliation">
              <i class="el-icon-sort"></i>
              <span slot="title">对账</span>
            </el-menu-item>-->

            <!-- <el-submenu index="/home/financial">
              <template slot="title">
                <i class="el-icon-money"></i>
                <span slot="title">理财管理</span>
              </template>
              <el-menu-item index="/home/contractAssets">
                <span slot="title">资产管理</span>
              </el-menu-item>
            </el-submenu> -->
            <!-- <el-submenu index="/home/cornucopia/projects">
                  <template slot="title">
                    <span slot="title">活期宝</span>
                  </template>
                  <el-menu-item index="/home/cornucopia/projects"
                    >活期宝设置</el-menu-item
                  >
                </el-submenu>
                <el-submenu index="/home/cornucopia/pledgeSetting">
                  <template slot="title">
                    <span slot="title">定期宝</span>
                  </template>
                  <el-menu-item index="/home/cornucopia/pledgeSetting"
                    >定期宝设置</el-menu-item
                  >
                </el-submenu> -->

            <!-- <el-submenu index="home/otc">
              <template slot="title">
                <i class="el-icon-money"></i>
                <span slot="title">OTC管理</span>
                
              </template>
              <el-menu-item index="/home/otc/otcUserList">
                <span slot="title">otc用户列表</span>
              </el-menu-item>
              <el-menu-item index="/home/otc/plan">
                <span slot="title">计划委托</span>
              </el-menu-item>
              <el-menu-item index="/home/otc/profitLoss">
                <span slot="title">止盈止损</span>
              </el-menu-item>
              </el-submenu> -->
            <!-- <el-submenu index="/home/orderControl" v-if="userInfo.isSupper">
              <template slot="title">
                <i class="el-icon-files"></i>
                <span slot="title">账单管理</span>
              </template>
              <el-menu-item index="/home/userBill" v-if="userInfo.roleId === 0">
                <i class="el-icon-document"></i>
                <span slot="title">用户账单</span>
              </el-menu-item>
              <el-menu-item index="/home/abnormal" v-if="userInfo.roleId === 0">
                <i class="el-icon-document-delete"></i>
                <span slot="title">充值异常数据列表</span>
              </el-menu-item>
              <el-menu-item
                index="/home/timeOutData"
                v-if="userInfo.roleId === 0"
              >
                <i class="el-icon-timer"></i>
                <span slot="title">业务超时数据列表</span>
              </el-menu-item>

              <el-menu-item index="/home/bill">
                <i class="el-icon-collection"></i>
                <span slot="title">用户充提记录</span>
              </el-menu-item>
            </el-submenu> -->

            <!-- <el-menu-item
              index="/home/balanceSearch"
              v-if="userInfo.roleId === 0"
            >
              <i class="el-icon-wallet"></i>
              <span slot="title">钱包余额查询</span>
            </el-menu-item> -->

            <!-- <el-menu-item index="/home/logs">
              <i class="el-icon-printer"></i>
              <span slot="title">监控日志</span>
            </el-menu-item>-->
            <!-- <el-submenu index="/home/mytoken" v-if="userInfo.roleId === 0">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">MyToken设置</span>
              </template>
              <el-menu-item index="/home/mytoken/currency">币种设置</el-menu-item>
              <el-menu-item index="/home/mytoken/ticker">查看行情</el-menu-item>
            </el-submenu>-->
            <!-- <el-submenu index="/home/UserDividend">
              <template slot="title">
                <i class="el-icon-user"></i>
                <span slot="title">用户分红</span>
              </template>
              <el-menu-item index="/home/UserDividend/projects"
                >分红任务</el-menu-item
              >
            </el-submenu> -->
            <!-- <el-submenu index="/home/dividend">
              <template slot="title">
                <i class="el-icon-dish-1"></i>
                <span slot="title">股东分红</span>
              </template>
              <el-menu-item index="/home/dividend/task">分红任务</el-menu-item>
              <el-menu-item index="/home/dividend/shareholder"
                >股东信息</el-menu-item
              >
            </el-submenu> -->
            <!-- <el-submenu index="/home/ordertask">
              <template slot="title">
                <i class="el-icon-money"></i>
                <span slot="title">择机下单</span>
              </template>
              <el-menu-item index="/home/ordertask/list">任务列表</el-menu-item>
              <el-menu-item index="/home/ordertask/user_balances"
                >用户余额</el-menu-item
              >
            </el-submenu> -->
            <!-- <el-submenu index="/home/vote" v-if="userInfo.roleId === 0">
              <template slot="title">
                <i class="el-icon-sort"></i>
                <span slot="title">投票设置</span>
              </template>
              <el-menu-item index="/home/vote/batchSetting"
                >批次设置</el-menu-item
              >
              <el-menu-item index="/home/vote/coinSetting"
                >币种设置</el-menu-item
              >
            </el-submenu> -->

            <!-- <el-submenu index="/home/message">
              <template slot="title">
                 <i class="el-icon-message"></i>
                <span slot="title">短信群发</span>>
              </template>
              <el-menu-item index="/home/message/template">模版设置</el-menu-item>
              <el-menu-item index="/home/message/tasks">发送任务</el-menu-item>
            </el-submenu>-->

            <!-- <el-submenu index="/home/pledge" v-if="userInfo.roleId === 0">
              <template slot="title">
                 <i class="el-icon-circle-close-outline"></i>
                <span slot="title">存币生息</span>
              </template>
              <el-menu-item index="/home/pledge/coefficient">锁仓系数</el-menu-item>
              <el-menu-item index="/home/pledge/interest">项目列表</el-menu-item>
            </el-submenu>-->

            <!-- <el-submenu index="/home/votingStrategy">
              <template slot="title">
                <i class="el-icon-d-caret"></i>
                <span slot="title">社区投票</span>
              </template>
              <el-menu-item index="/home/votingStrategy/projects"
                >项目列表</el-menu-item
              >
              <el-menu-item index="/home/votingStrategy/records">投资记录</el-menu-item>
            </el-submenu> -->
            <!-- <el-submenu index="/home/quiz">
              <template slot="title">
                 <i class="el-icon-d-caret"></i>
                <span slot="title">竞猜</span>
              </template>
              <el-menu-item index="/home/quiz/projects">项目列表</el-menu-item>
              <el-menu-item index="/home/votingStrategy/records">投资记录</el-menu-item>
            </el-submenu>-->

            <!-- <el-menu-item index="/home/txRecord" v-if="userInfo.roleId === 0">
              <template slot="title">
                <Incoming
                  :style="iconStyle"
                  theme="outline"
                  size="18"
                  :fill="
                    this.$route.path == '/home/txRecord' ? '#409EFF' : '#303133'
                  "
                  :strokeWidth="2"
                />
                <span slot="title">TX录入</span>
              </template>
            </el-menu-item> -->
            <!-- <el-submenu index="/home/statistics" v-if="userInfo.roleId === 0"> -->
            <!-- <el-submenu index="/home/statistics" >
              <template slot="title">
                <Analysis
                  :style="iconStyle"
                  theme="outline"
                  size="18"
                  :fill="
                    this.$route.path == '/home/statistics'
                      ? '#409EFF'
                      : '#303133'
                  "
                  :strokeWidth="2"
                />
                <span slot="title">统计表</span>
              </template>
              <el-menu-item index="/home/statistics/registered">
                <template slot="title">
                  <Peoples
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/statistics/registered'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">注册人数统计</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/statistics/loginLog">
                <template slot="title">
                  <Log
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/statistics/loginLog'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">登录日志</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/statistics/charge">
                <template slot="title">
                  <Currency
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/statistics/charge'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">手续费列表</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/statistics/assets">
                <template slot="title">
                  <Bank
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/statistics/assets'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">资产统计</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/statistics/snapshoot">
                <template slot="title">
                  <Funds
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/statistics/snapshoot'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">余额快照</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/statistics/trade">
                <template slot="title">
                  <ExchangeThree
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/statistics/trade'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">交易统计</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/statistics/etf">
                <template slot="title">
                  <Repair
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/statistics/etf'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title"> ETF 统计</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/statistics/recharge">
                <template slot="title">
                  <IncomeOne
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/statistics/recharge'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">充值统计</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/statistics/widthdraw">
                <template slot="title">
                  <ExpensesOne
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/statistics/widthdraw'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">提现统计</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/statistics/order">
                <template slot="title">
                  <Order
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/statistics/order'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">订单统计</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/home/statistics/deal">
                <template slot="title">
                  <Transaction
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/statistics/deal'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">成交记录</span>
                </template>
              </el-menu-item>
            </el-submenu> -->

            <!-- 理财功能 -->
            <!-- <el-submenu index="/home/financial">
              <template slot="title">
                <DataFile
                  :style="iconStyle"
                  theme="outline"
                  size="18"
                  :fill="
                    this.$route.path == '/home/financialStatements'
                      ? '#409EFF'
                      : '#303133'
                  "
                  :strokeWidth="2"
                />
                <span slot="title">理财功能</span>
              </template>
              <el-menu-item index="/home/financial/currentTreasure">
                <template slot="title">
                  <Financing
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/financial/currentTreasure'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">活期宝</span>
                </template>
              </el-menu-item>

              <el-menu-item index="/home/financial/staking">
                <template slot="title">
                  <FinancingOne
                    :style="iconStyle"
                    theme="outline"
                    size="18"
                    :fill="
                      this.$route.path == '/home/financial/staking'
                        ? '#409EFF'
                        : '#303133'
                    "
                    :strokeWidth="2"
                  />
                  <span slot="title">staking</span>
                </template>
              </el-menu-item>
            </el-submenu> -->
            <!-- 消息推送 -->
            <el-submenu index="/home/msgManagement" v-if="isBackendTab">
              <template slot="title">
                <TextMessage :style="iconStyle" theme="outline" size="18" :fill="this.$route.path == '/home/msgManagement' ? '#409EFF' : '#303133'
                  " :strokeWidth="2" />
                <span slot="title">消息推送管理</span>
              </template>
              <el-menu-item index="/home/msgChannelManage">
                <AssemblyLine :style="iconStyle" theme="outline" size="18" :fill="this.$route.path == '/home/msgChannelManage' ? '#409EFF' : '#303133'
                  " :strokeWidth="2" />
                <span slot="title">消息通道</span>
              </el-menu-item>
              <el-menu-item index="/home/msgChannelSourceManage">
                <AssemblyLine :style="iconStyle" theme="outline" size="18" :fill="this.$route.path == '/home/msgChannelSourceManage' ? '#409EFF' : '#303133'
                  " :strokeWidth="2" />
                <span slot="title">消息类型与通道</span>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-main v-if="showSpot">
          <router-view></router-view>
        </el-main>
        <!-- </div> -->
        <div v-if="showFutures" style="width: 100%" id="gameFrame">
          <iframe ref="iframe" :src="iframeSrc" width="100%" height="100%" frameborder="0"></iframe>
        </div>
        <div v-if="showOtc" style="width: 100%" id="gameFrame">
          <iframe ref="iframe" :src="iframeOtcSrc" width="100%" height="100%" frameborder="0"></iframe>
        </div>
        <div v-if="showFinancial" style="width: 100%" id="gameFrame">
          <iframe ref="iframe" :src="iframeFinancialSrc" width="100%" height="100%" frameborder="0"></iframe>
        </div>
        <div></div>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import cookies from 'js-cookie'
import http from './plugins/axios'
import encrypt from '@/utils/encrypt'
import collapseImg from '@/assets/collapse.png'
import collapseActive from '@/assets/collapseActive.png'

import {
  FinancingOne,
  Seal,
  TransferData,
  TextMessage,
  RowHeight,
  Trademark,
  Order,
  DoorHandle,
  AssemblyLine,
  DataFile,
  ExpensesOne,
  ConnectAddressOne,
  TransactionOrder,
  Permissions,
  BankTransfer,
  Balance,
  Wallet,
  WalletTwo,
  XiaoduHome,
  Funds,
  Paypal,
  ListView,
  Find,
  Api,
  Layers,
  International,
  Transform,
  Repair,
  Symmetry,
  Communication,
  MultiPictureCarousel,
  FreezeColumn,
  MindMapping,
  Carousel,
  Text,
  Finance,
  ParagraphUnfold,
  EmailPush,
  BuildingOne,
  Announcement,
  RobotOne,
  RobotTwo,
  EveryUser,
  SettingOne,
  Incoming,
  Analysis,
  Peoples,
  ExchangeThree,
  Log,
  IncomeOne,
  Transaction,
  Bank,
  Currency,
  MoreApp,
  TableReport,
  TwoDimensionalCodeTwo,
  City,
  Message,
  DoneAll,
  RopeSkipping,
  Control,
  Dropbox,
  Toolkit,
  Connect,
  ApplicationOne,
  AdProduct,
  Application,
  CategoryManagement,
  ConnectionBox,
  Financing,
} from '@icon-park/vue'

export default {
  name: 'HomePage',
  data() {
    return {
      collapseActive,
      collapseImg,
      showSpot: true,
      showBackend: false,
      showOtc: false,
      showFutures: false,
      showFinancial: false,
      token: cookies.get('admin-token'),
      iframeSrc: '',
      iframeOtcSrc: '',
      iframeFinancialSrc: '',
      isCollapse: false,
      changePasswordVisible: false,
      googleDialogVisible: false,
      changePasswordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      googleForm: {
        googleCode: '',
      },
      pendingAction: null,
      iconStyle: {
        display: 'inline-block',
        'margin-right': '8px',
        'margin-top': '-6px',
      },
    }
  },
  components: {
    Financing,
    FinancingOne,
    Seal,
    Toolkit,
    ApplicationOne,
    AdProduct,
    Application,
    CategoryManagement,
    Trademark,
    Bank,
    Connect,
    City,
    ConnectionBox,
    TextMessage,
    RowHeight,
    AssemblyLine,
    ExchangeThree,
    TransferData,
    Message,
    DoneAll,
    Currency,
    TableReport,
    DataFile,
    Order,
    Layers,
    DoorHandle,
    RopeSkipping,
    Control,
    ExpensesOne,
    Balance,
    IncomeOne,
    XiaoduHome,
    ConnectAddressOne,
    MoreApp,
    SettingOne,
    TransactionOrder,
    TwoDimensionalCodeTwo,
    Permissions,
    Transaction,
    Repair,
    BankTransfer,
    Funds,
    Api,
    Wallet,
    WalletTwo,
    Finance,
    Paypal,
    ListView,
    Dropbox,
    Find,
    International,
    Transform,
    Symmetry,
    Communication,
    MultiPictureCarousel,
    FreezeColumn,
    MindMapping,
    Carousel,
    Text,
    ParagraphUnfold,
    EmailPush,
    BuildingOne,
    Announcement,
    RobotOne,
    RobotTwo,
    EveryUser,
    Incoming,
    Analysis,
    Peoples,
    Log,
  },

  computed: {
    ...mapState(['userInfo']),
    isRiskAccount() {
      const account =
        this.userInfo && this.userInfo.account ? this.userInfo.account : ''
      return String(account).toLowerCase().includes('risk')
    },
    isSpotTab() {
      return this.showSpot && !this.showBackend
    },
    showFullSpotMenus() {
      return this.isSpotTab && !this.isRiskAccount
    },
    showFullBackendMenus() {
      return this.isBackendTab && !this.isRiskAccount
    },
    isBackendTab() {
      return this.showSpot && this.showBackend
    },
    isCustom() {
      const roles =
        this.userInfo && Array.isArray(this.userInfo.roles)
          ? this.userInfo.roles
          : []
      return roles.some(
        (item) => item.productId === 5 && item.name === '客服'
      )
    },
  },
  methods: {
    ...mapActions(['logout']),
    ...mapActions('topPartner', ['getTopPartner']),
    ...mapMutations('topPartner', ['setTopPartner']),
    ...mapActions('userTiger', ['getSymbolList']),

    showChangePassword() {
      this.changePasswordVisible = true
    },
    closeChangePasswordDialog() {
      this.changePasswordVisible = false
      this.changePasswordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      }
    },
    closeGoogleDialog() {
      this.googleDialogVisible = false
      this.googleForm = {
        googleCode: '',
      }
      this.pendingAction = null
    },
    validatePasswordRule(password) {
      const rule =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/
      return rule.test(password)
    },
    submitChangePassword() {
      const { oldPassword, newPassword, confirmPassword } =
        this.changePasswordForm
      if (!oldPassword) {
        this.$message.error('请输入旧密码')
        return
      }
      if (!newPassword) {
        this.$message.error('请输入新密码')
        return
      }
      if (!this.validatePasswordRule(newPassword)) {
        this.$message.error(
          '新密码至少8位，且必须包含数字、大写字母、小写字母和符号'
        )
        return
      }
      if (!confirmPassword) {
        this.$message.error('请再次输入新密码')
        return
      }
      if (newPassword !== confirmPassword) {
        this.$message.error('两次输入的新密码不一致')
        return
      }
      if (oldPassword === newPassword) {
        this.$message.error('新密码不能与旧密码相同')
        return
      }
      this.pendingAction = () => {
        return http
          .post({
            url: '/la/admin/password/change',
            data: {
              oldPassword: encrypt(oldPassword),
              newPassword: encrypt(newPassword),
            },
          })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('修改密码成功')
              this.closeGoogleDialog()
              this.closeChangePasswordDialog()
              setTimeout(() => {
                this.logout()
              }, 300)
            }
          })
      }
      this.googleDialogVisible = true
    },
    confirmGoogleForPassword() {
      if (!this.googleForm.googleCode) {
        this.$message.error('请输入谷歌验证码')
        return
      }
      http
        .post({
          url: `/la/admin/google/check?googleCode=${this.googleForm.googleCode}`,
        })
        .then((res) => {
          if (res.code == 0 && this.pendingAction) {
            this.pendingAction()
          }
        })
    },
    getFuturesOrigin(targetPath = '') {
      const isLocalDev =
        process.env.NODE_ENV === 'development' &&
        /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)
      const { protocol } = window.location
      const domainSuffix = this.getDomain()
      console.log('domainSuffix', domainSuffix)
      const normalizedPath = targetPath
        ? targetPath.startsWith('/')
          ? targetPath
          : `/${targetPath}`
        : ''
      // this.iframeSrc = `${protocol}//futures-admin.${domainSuffix}/?token=${this.token}`
      const riskMode = this.isRiskAccount ? '&riskMode=1' : ''
      this.iframeSrc = isLocalDev
        ? `http://localhost:8081${normalizedPath}?token=${this.token}&embed=1${riskMode}`
        : `${protocol}//contract.${domainSuffix}${normalizedPath}?token=${this.token}&embed=1${riskMode}`
    },
    getOtcOrigin() {
      const { protocol } = window.location
      const domainSuffix = this.getDomain()
      this.iframeOtcSrc = `${protocol}//otc-admin.${domainSuffix}/?token=${this.token}`
    },
    getFinancialOrigin() {
      const { protocol } = window.location
      const domainSuffix = this.getDomain()
      cookies.set('admin-token', this.token, { domain: '.lvbit.pro' })
      // cookies.set('admin-token', this.token, { domain: '.admin.pixelex.co' })
      this.iframeFinancialSrc = `${protocol}//financial-admin.${domainSuffix}/?token=${this.token}`
    },
    toTigger() {
      this.showSpot = false
      this.showBackend = false
      this.showOtc = false
      this.showFinancial = false
      this.showFutures = true
      this.getFuturesOrigin()
    },
    toFinancial() {
      this.showSpot = false
      this.showBackend = false
      this.showOtc = false
      this.showFutures = false
      this.showFinancial = true
      this.getFinancialOrigin()
    },
    toOTC() {
      this.showFutures = false
      this.showSpot = false
      this.showBackend = false
      this.showOtc = true
      this.showFinancial = false
      this.getOtcOrigin()
    },
    getDomain() {
      const hostname = window.location.hostname
      const parts = hostname.split('.')
      const rootDomain = parts.slice(-2).join('.')
      const isTestEnv =
        parts.includes('test') || process.env.VUE_APP_ENV === 'test'

      console.log('isTestEnv', isTestEnv)
      console.log('rootDomain', rootDomain)
      console.log('parts', parts)
      console.log('hostname', hostname)
      // 测试环境 → contract.test.qianyang.pro；UAT/生产 → contract.qianyang.pro
      if (isTestEnv) {
        return `test.${rootDomain}`
      }
      return rootDomain
    },
    toSpot() {
      this.showSpot = true
      this.showBackend = false
      this.showFutures = false
      this.showOtc = false
      this.showFinancial = false
      const p = this.$route.path
      if (
        p === '/home/msgChannelManage' ||
        p === '/home/msgChannelSourceManage' ||
        p === '/home/msgManagement'
      ) {
        this.$router.replace('/home/setting/tradePair')
      }
    },
    toBackend() {
      this.showSpot = true
      this.showBackend = true
      this.showFutures = false
      this.showOtc = false
      this.showFinancial = false
    },
    toReport() {
      this.$router.push('/home/financialStatements')
    },
  },
  mounted() {
    if (this.isRiskAccount) {
      if (this.$route.path.indexOf('/home/audit') === 0) {
        this.toBackend()
      } else {
        this.toTigger()
      }
    } else if (!this.isCustom) {
      const p = this.$route.path
      if (p === '/home/msgChannelManage' || p === '/home/msgChannelSourceManage') {
        this.toBackend()
      }
    }
    this.getTopPartner({
      page: 1,
      size: 100000,
      channelUserId: '',
      phone: '',
      email: '',
    }).then((res) => {
      // this.setTopPartner(res.data.list?this.res.data.list[0].id:'')
    })
    // this.getSymbolList()
    console.log(process.env)
    this.getFuturesOrigin()
  },
}
</script>

<style lang="less" scoped>
.home-page {
  display: flex;
  height: 100%;
  background-color: #f5f7fa;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #dcdfe6;
  background-color: #fff;

  .el-dropdown-link {
    cursor: pointer;
  }

  .logo {
    cursor: pointer;
    margin: 0 20px;
    font-weight: 600;
    font-size: 18px;
    color: #303133;

    // transition: all 0.3s ease;
    &.active,
    &:hover {
      padding-bottom: 16px;
      border-bottom: 3px solid #4aa2ff;
    }
  }
}

.aside {
  height: 100vh;
  background-color: #fff;
  border-right: 1px solid #dcdfe6;
  position: relative;

  .el-menu {
    border: 0;
  }
}

.el-dropdown-menu__item,
.el-menu-item {
  padding: 0;
}

.exit {
  width: 76px;
  display: block;
  text-align: center;
  height: 100%;
}

.collapseImg {
  cursor: pointer;
  width: 10px;
  height: 47px;
  position: absolute;
  top: 10px;
  z-index: 999;
  right: 0;
}
</style>
